<i18n lang='yml' src='../i18n/LogbookHours.yml'></i18n>

<template>

  <div class="logbook_hours">
    
    <flash :message_type="message_type" :message_text="message_text"/>
    <div class="heading-block mb-0 d-flex">
      <h4>
        <span class="apprentice-name" v-if="allow_approval == 'true' && logbookData && logbookData.user_identity.external_identifiers">
          {{logbookData.user_identity.last_name}}, {{logbookData.user_identity.first_name}} ({{logbookData.user_identity.external_identifiers.sto_id}})
        </span>
        <span class="program-name"> {{logbookData ? logbookData.name : "" }}{{!logbookData ? $t('management') : "" }}</span> 
      </h4>
    </div>
    <div v-if="logbookData" :class="allow_approval == 'true' ? 'mb-0' : ''" class="heading-block post-meta no-padding-meta top-shadow"> 
      <ul class="list-inline list-annotation has-select-input">
        <li class="progress-component" v-if="logbookData.get_tracking_information.skills_tracking">
          <progress-bar 
              :percentage_value="logbookData.get_progress.percent" 
              :approved="logbookData.get_progress.completed_count"
              :total="logbookData.get_progress.mandatory_count"
              progress_message='progress-message-skills'
              type="success">
          </progress-bar>
        </li>   
        <li class="progress-component" v-if="logbookData.get_tracking_information.hours_tracking">
          <progress-bar 
            :percentage_value="logbookData.get_hour_progress.percent"
            :approved="logbookData.get_hour_progress.completed_hours"
            :total="logbookData.get_hour_progress.required_hours"
            progress_message='progress-message-hours'
            type="custom">
          </progress-bar>
        </li>
       <!-- Logbook Approval -->
        <li v-if="allow_approval == 'true'" class="ml-md-auto select-input-wrap">
          <div class="input-group input-group-sm">
            <select :disabled="logbookData.status == 'incomplete'" ref="dropdown_logbook_approval" id="dropdown_logbook_approval" :name="$t('dropdown_logbook_approval')" class="select-dropdown custom-select form-control-sm" v-model="logbookUpdateStatus">
              <option :value="null" disabled>{{$t('select_logbook_status')}}</option>
              <option value='meets_requirements' :disabled="!isLocked">
                {{ $t('logbook_unapprove') }}
              </option>
              <option value='approved' :disabled="logbookData.status != 'meets_requirements'">
                {{ $t('logbook_approve') }}
              </option>
            </select>
            <div class="input-group-append">
              <button :disabled="logbookData.status == 'incomplete'" class="btn btn-sm btn-success" href="#" @click="submitLogbookStatusChange()">
                {{ $t('save') }}
              </button>
            </div>
          </div>
        </li>
      </ul>
    </div>
    
    <div v-if=" logbookData">
      <ul class="list-inline list-annotation border-top-0 border-bottom mb-0"> 
        <li>{{ $t('logbook_status') }}
          <span class="status-badge">
            {{ $t(logbookData.status) }}
          </span>
        </li>
        <li>{{ $t('last_updated') }} {{ formatDate(logbookData.get_last_update)}}</li> 
      </ul>
    </div>
    <div v-else-if="hours.length == 0">
      <div class="alert alert-warning" role="alert">
        {{noDataError}}
      </div>
    </div>
    <div class="content-block content-block-logbook" v-else :key="skillSet.id" v-for="skillSet in skillSetsList">
      <div class="post-meta" v-if="!skillSet.required || isApprover || !logbookData">
        <ul class="list-inline list-annotation">
          <li class="list-inline-item pt-0" v-if="!skillSet.required">
            <span class="badge yellow-bg">{{ $t('optional') }}</span>
          </li>
          <li class="list-inline-item ml-auto" v-if="logbookData && isApprover" >
            <label :for="`select-skill-set-${skillSet.id}`" class="check-select">
              <input :disabled="isLocked || isApproved(skillSet)" :id="`select-skill-set-${skillSet.id}`" v-model="bulkUpdateSkillSets" type="checkbox" :value="skillSet.id" /> 
              <span>{{ $t('select') }}</span>
            </label>
          </li>
          <li class="list-inline-item ml-auto" v-if="!logbookData" >
            <div v-if="edit =='true'" class="btn-group btn-group-sm ml-auto">
              <a class="btn btn-outline-primary" :href="`skill_sets/${skillSet.id}/edit`">
                <font-awesome-icon :icon="['fas', 'edit']" />
                {{ $t('edit') }}
              </a>
            </div>
          </li>
        </ul>
      </div>
      <div class="post-view">
        <div class="post-content"  >
          <div class="view-area">
            <h5 class="mb-0" :class="logbookData ? 'heading-content' : 'container-item-name'">
              <a :href="`skill_sets/${skillSet.id}/skills`">{{ skillSet.skill_set_code }} - {{ skillSet.name[locale] }}</a>
            </h5>
            <div v-if="!logbookData && skillSet.description[locale] && skillSet.description[locale].length > 0" class="fr-view description clearfix">
               <more-less :descriptionText="skillSet.description[locale]" /> -->
              <span class="sr-only" v-html="skillSet.description[locale]"></span>
            </div>
          </div>
        </div>
      </div>
      <hr class="m-0"/>
      <div class="post-meta" v-if="logbookData">
        <ul class="list-inline list-annotation">
         <li>
          <span class="wrap-items">{{ $t('status') }} {{ skillSetStatusMapping[`skill_set_${skillSet.id}_status`] ? skillSetStatusMapping[`skill_set_${skillSet.id}_status`].name : $t('incomplete')}}</span>       
          <span class="wrap-items" v-if="skillSet.status">{{ $t('last_updated') }} {{ formatDate(skillSet.status.updated_at)}}</span>
          </li>
          <li v-if="skillSet.progress" class="progress-component">
            <progress-bar 
              :percentage_value="skillSet.progress.percent" 
              :approved="skillSet.progress.completed_count" 
              :total="skillSet.progress.mandatory_count" 
              progress_message='progress-message-skills'
              type="success">
            </progress-bar>
          </li>
        </ul>
      </div>
    </div>
    <div id="hours-block">
      <h5 class="heading-page mb-2">{{$t('hours')}}</h5>


      <div class="mockDropdown">
        <a v-if="currentActiveAgreement" href="#" :class="`${!isDropdownHidden? 'active' : ''} dropdown-name`" @click.prevent="isDropdownHidden = !isDropdownHidden">
          <span v-if='currentActiveAgreement.container' :title="currentActiveAgreement.container.name" class="name">{{ generateName(currentActiveAgreement.container.name)}}
            <span class="tab-svg">
              <span v-if="currentActiveAgreement.primary">
               {{$t('primary')}}
              </span>
              <span v-else><span class='tab-dash'>-</span>{{`${$t(currentActiveAgreement.status)}`}}</span>
            </span>
          </span>
          <span v-else>
            {{currentActiveAgreement}}
          </span>
          <span class="dropdown-caret"> 
            <font-awesome-icon :icon="['fas', 'angle-down']" />
          </span>
        </a>
  
        <ul v-if="agreements.length > 0" class="nav nav-tabs" :class="`${isDropdownHidden ? 'd-none' : ''}`">
          <li class="nav-item" v-for="item in agreements" :key="`${item.container_id}-tab`" >
            <a class="nav-link" @click.prevent="setActive(item)" 
            :class="`${isActive(item.container_id)? 'active' : ''} 
            ${isPrimary(item.container_id)? 'primary' : ''}`" :href="`#${item.container_id}-contents`">
              <span class="name" :title="item.container.name">{{generateName(item.container.name)}}</span>
                <span class="tab-svg">
                <span class='tab-dash'>-</span> 
                {{`${$t(item.status)}`}}
                <span v-if="item.primary">
                / {{$t('primary')}}
                </span>
              </span>
            </a>
          </li>
          <li class="nav-item ml-auto nav-item history-tab">
            <a class="nav-link" :title="$t('history')" @click.prevent="setActive('history')"  :class="`${isActive('history')? 'active' : ''}`" href="#history">{{ $t('history') }}</a>
          </li>
        </ul>
        <div v-else class="alert alert-warning" role="alert">{{$t('no_data')}}</div>
      </div>

      <div v-if="agreements.length > 0" class="tab-content">
        <div class="tab-pane fade" :key="`${item.container_id}-content`" v-for="item in agreements" :class="{ 'active show': isActive(item.container_id) }" :id="`${item.container_id}-contents`">
          <div v-if="!isActiveAgreement(item.status)" >
            <div class="alert alert-primary m-0" role="alert">
              {{ $t('inactive_training_agreement') }}
            </div>
          </div>
          <div class="d-flex my-3 hours_title_table">
            <span id="HoursTableTitle" d-flex> 
              <span v-if="isActiveAgreement(item.status)"> 
                {{ $t('active_training_agreement') }}   
              </span>
              <span v-else> 
                {{ $t('review_hours') }}   
              </span>    
            </span>

            <button v-if="isActiveAgreement(item.status)" :disabled="isLocked" class="btn btn-sm btn-primary" @click="setAddingRow">
              {{ $t('add_row') }}
            </button>
          </div>
          <scroll-shadow>
            <div class="table-container" id="table-container-hours" role="table" aria-describedby="HoursTableTitle">
              <div class="flex-table-hours" role="rowgroup">
              <div class="flex-row flex-row-short table-header" role="columnheader">{{ $t('start_date') }}</div>
              <div class="flex-row flex-row-short table-header" role="columnheader">{{ $t('end_date') }}</div>
              <div class="flex-row flex-row-long table-header" role="columnheader">{{ $t('hours_column') }}</div>
              <div class="flex-row flex-row-short-left table-header" role="columnheader">{{ $t('comment') }}</div>
              <div class="flex-row flex-row-short table-header" role="columnheader">{{ $t('status') }}</div>
              <div v-if="!isLocked" :class="`flex-row flex-row-short table-header ${isActiveAgreement(item.status) ? '' : 'd-none'}`" role="columnheader">{{ $t('actions') }}</div>
            </div>
            <hours-form-row 
              v-if="addingRow" 
              :container_training_agreement="item" 
              :load_path="load_path"
              :logbook="logbookData"
              @setFlash="setFlash"
              @closeHourFormRow="closeHourFormRow"
              type="new"
              :approved="logbookData.get_hour_progress.completed_hours"
              :total="logbookData.get_hour_progress.required_hours"
            />
        
            <div v-if="item.logbook_hours.length == 0" class="alert alert-warning" role="alert">
              {{ $t('no_hours') }}
            </div> 
            
            <div :class="isOverflowing ? 'fill-table' : ''" v-for="row of (item.logbook_hours)" :key="row.id" v-else>
              <hours-form-row 
                v-if="editing.includes(row.id)" 
                :load_path="load_path"
                :logbook_hour="row" 
                :logbook="logbookData" 
                @setFlash="setFlash"
                @closeHourFormRow="closeHourFormRow"
                type="edit" 
                :container_training_agreement="item"
              />
              <div class="flex-table-hours" role="rowgroup" v-else>
                <div class="flex-row flex-row-short first" role="cell">
                
                    {{ formatDate(row.start_date) }}
                
                </div>
                <div class="flex-row flex-row-short" role="cell">
            
                    {{ formatDate(row.end_date) }}
              
                </div>
                <div class="flex-row flex-row-long" role="cell">
                    
                    {{ formatLogbookHours(row.hours) }}
              
                </div>
                <div class="flex-row flex-row-short" role="cell">
                    
                    <button class="btn btn-sm btn-outline-secondary btn-comment" @click="toggleComment(row.id)" :class="{ active: hasComment(row.comment) }" >
                      <label class="sr-only" for="comment_button"> {{ addSrLabel(row.comment) }} </label>
                      <font-awesome-icon :icon="['far', 'comment-alt']" v-if="row.comment==''"/>
                      <font-awesome-icon :icon="['fas', 'comment-alt-check']" v-else/>
                    </button>
                  
                </div>
                <div class="flex-row flex-row-short" role="cell">
                  <span class="status-bold">
                    {{ $t(row.status) }}
                  </span>
                </div>
                <div v-if="item.status == 'active' && !isLocked" :class="`flex-row flex-row-short ${isActiveAgreement(item.status) ? '' : 'd-none'}`" role="cell">
                  <span v-if="item.status == 'active'">
                    <button class="dropdown-toggle btn btn-sm btn-outline-secondary" data-toggle="dropdown" href="#" :disabled="row.status == 'confirmed' && allow_approval == 'false'">
                      <span class="sr-only">dropdown-toggle</span>
                      <font-awesome-icon :icon="['fa', 'cog']"/>
                    </button>

                    <div class="dropdown-menu" role="navigation">
                      <a class="dropdown-item" v-if="allow_approval == 'true' && row.status == 'pending'" 
                        href="#" @click="updateHours($event, row.id)"> {{ $t('action_buttons.confirm') }} 
                      </a>
                      <a class="dropdown-item" v-if="allow_approval == 'true' || row.status == 'pending'" 
                        @click="editRow(row)"> {{ $t('action_buttons.edit') }} </a>
                      <a class="dropdown-item" v-if="allow_approval == 'true' || row.status == 'pending'" 
                        href="#" @click="deleteHours($event, row.id)"> {{ $t('action_buttons.delete_hours') }} 
                      </a>
                    </div>
                  </span>
                  
                </div>
              </div>
              <div class="flex-table-hours">
                <div class="flex-row-full" role="cell" v-if="show && activeComment == row.id">
                    <span v-if="row.comment && row.comment != ''"> 
                      {{ row.comment }}
                    </span>
                    <span v-else> 
                      {{ $t('empty_comment_state') }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </scroll-shadow>
          <pagination  @items_changed="setItems($event, item)" :items="item.totalLogbookHours" :pagination_limit="pagination_limit"/>
          <hr/>
          <div class="hours-summary mt-3">
            <h6 class="summary-heading">{{$t('logbook_hours.label')}}</h6>
            <div class="line-item">
              <div>
                {{ $t('logbook_hours.confirmed_hours') }}
              </div> 
              <div class="hightlight-value">{{ formatLogbookHours(calculateConfirmedHours(item.logbook_hours)) }}</div>
            </div>

            <div class="line-item">
              <div>
                {{ $t('logbook_hours.requested_hours') }}
              </div> 
              <div class="hightlight-value">{{ formatLogbookHours(calculatePendingHours(item.logbook_hours)) }}</div>
            </div>
            <hr/>
            <h6 class="summary-heading mt-2"> {{$t('logbook_hours.credited_hours')}}</h6>
            <div class="line-item">
              <div>
                {{ $t('logbook_hours.credited_on_job_hours') }}
              </div> 
              <div class="hightlight-value">{{ formatLogbookHours(item.work_credit_hours) }}</div>
            </div>

            <div class="line-item">
              <div>
                {{ $t('logbook_hours.previous_education_hours') }}
              </div> 
              <div class="hightlight-value">{{ formatLogbookHours(item.education_credit_hours) }}</div>
            </div>

            <hr/>

            <div class="line-item highlight_total"><div>{{ $t('logbook_hours.total_hours') }}</div> 
              <div class="hightlight-value">{{ calculateTotalConfirmedAndCreditedHours(item) }}</div>
            </div>

            <div class="alert alert-info"> {{$t('logbook_hours.alert_text')}}</div>

          </div> 
        </div>
        <div v-if="agreements.length > 0" class="tab-pane fade" :class="{ 'active show': isActive('history') }" id="history">
          <hours-history-tab :hours_changes="hoursHistory" :active_item="activeItem" :expansion_threshold="expansion_threshold" :pagination_limit='pagination_limit'/>
        </div>
        
      </div>
    </div>
    
    </div>
</template>
<script>
  import LoadingAnimation from '../../shared/loader/components/LoadingAnimation.vue';
  import ProgressBar from '../../shared/progress_bar/ProgressBar.vue'
  import HoursFormRow from './HoursFormRow.vue'
  import HoursHistoryTab from './HoursHistoryTab.vue'
  import { format, parse, isValid } from 'date-fns';
  import {formatDate, formatLogbookHours} from '../../shared/typescripts/dates.ts'
  import flash from '../../shared/flash_messages/components/Flash.vue';
  import MoreLess from '../../shared/more_less_component/MoreLess.vue'
  import pagination from '../../shared/pagination/Pagination.vue';
  import { sendAjaxRequest } from '../../shared/typescripts/ajax.ts';


  export default { 
    props: [
      'locale',
      'ctas',
      'logbook',
      'allow_approval',
      'load_path',
      'edit_path',
      'hours_history',
      'pagination_limit', 
      'expansion_threshold'
    ],
    components: {
      'loading-animation': LoadingAnimation,
      'hours-history-tab': HoursHistoryTab,
      'progress-bar': ProgressBar,
      'hours-form-row': HoursFormRow,
      'more-less': MoreLess,
      flash,
      pagination,
    },
    data() {
      return {
        error: false,
        loading: false,
        agreements: [],
        activeItem: '',
        hours: [],
        hoursHistory: [],
        logbookData: null,
        logbookUpdateStatus: null,
        show: { type: Boolean, default: false },
        activeComment: null,
        addingRow: false,
        editing: [],
        message_text: [],
        message_type: "error",
        isOverflowing: false,
        primary: '',
        isDropdownHidden: false,
        currentActiveAgreement: null,
        currentWidth: 0,
      }
    },

    mounted() {
      try {
        this.agreements = JSON.parse(this.ctas) || [];
        this.agreements.map((agreement) => {
          agreement.totalLogbookHours = agreement.logbook_hours;
        })
        let primary = this.findPrimary();
        this.activeItem = this.agreements[primary].container_id
        this.currentActiveAgreement = this.agreements[primary];
        this.primary = this.activeItem 
        this.hoursHistory = JSON.parse(this.hours_history) || []
        if ( window.innerWidth <= 1280) {
          this.isDropdownHidden = true;
          this.currentWidth  = document.getElementById("hours-block").clientWidth;
        } else {
          this.currentWidth = 200;
        }
      }
      catch(err) {
        this.error = true
      }

      try {
        this.logbookData = this.logbook ? JSON.parse(this.logbook) : null
        if(this.logbookData) {
          this.logbookSkillSetStatuses = JSON.parse(this.logbook_skill_set_statuses) || [];
        }
      }
      catch(err) {
        this.error = true;
      }

      window.addEventListener('resize', this.checkOverflowTable);

      window.addEventListener('resize', this.checkWidth);

    },

    computed: {
      isApprover: function() {
        return this.allow_approval == 'true';
      },

      isLocked: function() {
        return this.logbookData.status == 'approved';
      },

    },
  
    methods: {

      setItems(items, item) {
        item.logbook_hours = items
      },

      generateName(name) {
        this.currentWidth  = document.getElementById("hours-block").clientWidth;
        let padding = 0;
        if ( window.innerWidth <= 500) {
          padding = 40;
        }
        return this.truncateString(name, ((this.currentWidth - padding)/7.5))
      },

      truncateString(str, leng) {
        if (str.length > leng) {
          return str.substring(0, leng - 3) + '...';
        } else {
          return str;
        }
      },
      checkOverflowTable() {
        var element = document.getElementById("table-container-hours");
        if ( element && (element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth)) {
          this.isOverflowing = true
        } else {
          this.isOverflowing = false
        }
      },
  
      checkWidth() {
        if ( window.innerWidth <= 1280) {
          this.isDropdownHidden = true
          this.currentWidth  = document.getElementById("hours-block").clientWidth;
        } else {
          this.isDropdownHidden = false
          this.currentWidth = 200;
        }
      },
      /// - Find Primary - ///

      findPrimary() {
        var primaryAgreement = this.agreements.findIndex((agreement) => {
          return agreement.primary == true;
        })
        return primaryAgreement == -1 ? 0 : primaryAgreement;
      },

      /// - Tabs - ///
      isActive (menuItem) {
        return this.activeItem === menuItem
      },

      isPrimary (menuItem) {
        return this.primary === menuItem
      },

      setAddingRow() {
        this.addingRow = !this.addingRow
      },

      setActive (item) {
      if( typeof item == "object") {
            
            this.activeItem = item.container_id
            this.currentActiveAgreement = item
          } else {
            this.activeItem = item    
            this.currentActiveAgreement = item     
          }

          if ( window.innerWidth <= 1280) {
          this.isDropdownHidden = truegp

          }
  
      if(this.addingRow){
          this.setAddingRow();
        }

      },

      /// - Rows and Comments - ///

      rowStyleClassFn(row) {
        return row.comment ? 'childRow' : 'ParentRow';
      },

      hasComment(comment){
        if(comment){
          return true
        } 
      },

      toggleComment(row){
        this.checkOverflowTable()
        if(row == this.activeComment){
           this.show = !this.show;
        }
        else{
          this.show = true;
        }
        this.activeComment = row;
      },

      addSrLabel(comment) {
        if(comment && comment !== ""){
          return this.$t('sr_comment_exists');
        }
        else return this.$t('sr_comment_null');
      },

      /// - Formatting - ///

      formatDate(dateString) {
        return formatDate(dateString)
      },

      formatLogbookHours(rowObj) {
        return formatLogbookHours(rowObj)
      },


      /// - Hours Calculations - ///

      calculateTotalConfirmedAndCreditedHours(agreement) {
        let count = this.calculateConfirmedHours(agreement.logbook_hours);
        count += agreement.education_credit_hours;
        count += agreement.work_credit_hours;
        let required = this.logbookData.get_hour_progress.required_hours
        let percentage =  required == 0 ? 0 : Math.floor(count / required * 100)

        return `${this.formatLogbookHours(count)} ${this.$t('of')} ${required} (${percentage > 100 ? 100 : percentage}%)` ;
      },

      calculateEnteredHours: function(logbook_hours) {
        let count = 0;
        logbook_hours.forEach((item) => {
          if(item.hours){
            count += item.hours;
          }
        })
        return count;
      },

      calculateConfirmedHours: function(logbook_hours) {
        let count = 0;
        logbook_hours.forEach((item) => {
          if(item.hours && item.status == 'confirmed'){
            count += item.hours;
          }
        })
        return count;
      },


      calculatePendingHours: function(logbook_hours) {
        let count = 0;
        logbook_hours.forEach((item) => {
          if(item.hours && item.status == 'pending'){
            count += item.hours;
          }
        })
        return count;
      },


      /// - Logbook bar - ///

      submitLogbookStatusChange(){
        if(!this.logbookUpdateStatus) {
          return
        }
        var message = this.$t('logbook_approval_attestation')
        // Confirmation message
        if(this.logbookUpdateStatus == 'meets_requirements') {
          message = this.$t('confirm_revoke_logbook_approval')
        }
        // Confirmation
        if(!confirm(message)) {
          return
        }
        var current_url = window.location.href
        this.loading = true
        var method= 'PUT'
        var url= current_url.substring(0, current_url.lastIndexOf("/"));
        var data= {
          logbook_statuses: {
            status: this.logbookUpdateStatus,
          }
        }
        sendAjaxRequest(method, url, 'json', data, this.ajaxSuccess, this.ajaxError)
      },
      noDataError: function() {
        let params;
        try {
          params = JSON.parse(this.filter_params)
          if (params){
            return params['search'].value ? this.$t('no_search') : this.$t('no_data') ;
          }
        }
        catch(err) {
        this.error = true;  
        }
      },

      editRow(rowData){
        this.editing.push(rowData.id)
      },


      deleteHours(event, row_id) {
        event.preventDefault();
        if(!confirm(this.$t('confirm_delete'))) {
          return
        }
        this.loading = true
        var method = "DELETE"
        var url = `logbook_hours/${row_id}`

        sendAjaxRequest(method, url, 'json', {}, this.ajaxSuccess, this.ajaxError)
      },

      updateHours(event, row_id) {
        event.preventDefault();
        this.loading = true
        var method = 'PUT'   
        var url = `logbook_hours/${row_id}/update_status`
        sendAjaxRequest(method, url, 'json', {}, this.ajaxSuccess, this.ajaxError)
      },

      ajaxSuccess(data) {
        this.loading = false;
        window.location.reload();
        return data;
      },
      ajaxError(message) {
        this.message_type = "error";
        this.message_text.push(message.responseJSON.error)
      },

      setFlash(message) {
        this.message_type = message.type;
        this.message_text = message.text;
        window.scrollTo({top: 0, behavior: 'smooth'});
      },  

      isActiveAgreement(status) {
        return status == 'active' ? true : false
      },

      guideText(status){
        if(status == 'active'){
          return this.$i18n.t('active_training_agreement')
        }
        else return this.$i18n.t('inactive_guide_text')
      },

      // When cancel button pressed, close comment box.
      closeHourFormRow(data) {
        if (data.type == 'new') {
          this.addingRow = false 
        }
        else  {
          const index = this.editing.indexOf(data.row_id);
          if (index > -1) {
            this.editing.splice(index, 1);
          }
        }
      },  
    }
  }
</script>
